import { summaryStyle } from "../../consts/styles";
export default function SummaryBody(props) {
  return (
    <div>
      <span style={summaryStyle.textStyle}>{props.textdata}</span>
    </div>
  );
}
